export default [
  {
    header: 'Mis documentos',
    icon: 'PackageIcon',
    i18n: 'Mis Documentos',
    items: [
      {
        url: "/",
        name: "Todos",
        slug: "all",
        icon: "FileTextIcon",
      },
      {
        url: "/signed-documents",
        name: "Firmados",
        slug: "signed",
        icon: "CheckSquareIcon",
      },
      {
        url: "/partial-documents",
        name: "Pendientes",
        slug: "pending",
        icon: "AlertCircleIcon",
      },
      {
        url: "/reject-documents",
        name: "Rechazados",
        slug: "rejects",
        icon: "AlertTriangleIcon",
      },
   ]
  },
  {
    url: null,
    name: "Docs invitados",
    slug: "invited-documents",
    icon: "PlusCircleIcon",
    submenu: [
      {
        url: "/invited",
        name: "Todos",
        slug: "all",
        icon: "HomeIcon",
      },
      {
        url: "/invited/signed-documents",
        name: "Firmados",
        slug: "signed",
        icon: "FileIcon",
      },
      {
        url: "/invited/partial-documents",
        name: "Pendientes",
        slug: "pending",
        icon: "FileIcon",
      },
    ]
  },
  {
    url: "/archived",
    name: "Archivados",
    slug: "arhived",
    icon: "ArchiveIcon",
  },
  {
    header: 'Mi cuenta',
    icon: 'PackageIcon',
    i18n: 'Cuenta',
    items: [
      {
        url: null,
        name: "Carpetas",
        slug: "configuration",
        icon: "FolderIcon",
        submenu: [
          {
            url: "/configuration/work-folders",
            name: "Carpetas de trabajo",
            slug: "signed",
            icon: "FileIcon",
          },
          {
            url: "/configuration/users",
            name: "Usuarios",
            slug: "all",
            icon: "HomeIcon",
          },
        ]
      },

      {
        url: null,
        name: "Comprar",
        slug: "buy",
        icon: "CreditCardIcon",
        submenu: [
          {
            url: "/buy/purchases",
            name: "Compras",
            slug: "alfl",
            icon: "LayersIcon",
          },
          {
            url: "/buy/plans",
            name: "Planes",
            slug: "alsl",
            icon: "HomeIcon",
          },
          {
            url: "/buy/documents",
            name: "Firmas Adicionales",
            slug: "documents",
            icon: "HomeIcon",
          },
          {
            url: "/buy/payment-method",
            name: "Métodos de pago",
            slug: "alla",
            icon: "HomeIcon",
          },
          {
            url: "/configuration/tax-data",
            name: "Datos Fiscales",
            slug: "signed",
            icon: "FileIcon",
          },
        ]
      },

    {
      url: null,
      name: "Configuración",
      slug: "configuration",
      icon: "SettingsIcon",
      submenu: [
        {
          url: "/configuration/developers/api",
          name: "API desarrolladores",
          slug: "api",
          icon: "FileIcon",
        },
        {
          url: "/configuration/defaults",
          name: "Datos prestablecidos",
          slug: "default-settings",
          icon: "FileIcon",
        },
      ]
    },
    ]
  },

  {
    header: 'Sistema',
    icon: 'PackageIcon',
    i18n: 'Sistema',
    items: [
            {
        url: "https://validador.verificamex.com/",
        name: "Validador",
        icon: "CheckIcon",
        slug: "external",
        target: '_blank'
      },
      {
        url: "/login",
        name: "Salir",
        slug: "salir",
        icon: "PowerIcon"
      },
    ]
  },
]
